import group from "./operations/undo_group";
import {selectAll} from "./operations/column_operations";
import {styleFormats} from "./toolbar/buttons";
import {setOpenByRange} from "./operations/grouping/visibility";
import {getSelectedZones} from "./helpers/column_names";

export function init(view){
	const grid = view.$$("cells");
	const key = webix.env.isMac ? "command" : "ctrl";

	webix.UIManager.addHotKey(key+"-a", () => { if(!grid.getEditor()) selectAll(view); }, grid);
	webix.UIManager.addHotKey(key+"-p", (v, e) => dialog("print", view, e), grid);
	webix.UIManager.addHotKey(key+"-f", (v, e) => dialog("find", view, e), grid);
	webix.UIManager.addHotKey(key+"-h", (v, e) => dialog("find", view, e), grid);

	webix.UIManager.addHotKey(key+"-add", (v, e) => zoom(view, "in", e), grid);
	webix.UIManager.addHotKey(key+"-=", (v, e) => zoom(view, "in", e), grid);
	webix.UIManager.addHotKey(key+"-subtract", (v, e) => zoom(view, "out", e), grid);
	webix.UIManager.addHotKey(key+"-0", (v, e) => zoom(view, 1, e), grid);
	webix.UIManager.addHotKey(key+"-`", () => view.showFormulas("toggle"), grid);

	const wheelHandler = webix.event(
		view.$$("tableLayout").$view,
		"wheel",
		e => onWheel(view, grid, e)
	);
	view.attachEvent("onDestruct", () => webix.eventRemove(wheelHandler));

	if(!view.config.readonly){
		webix.UIManager.addHotKey("any", (view, ev) => {
			const code = ev.which || ev.keyCode;
			const f2 = code == 113;

			//ignore shift key, f1, f3 - f12 (f2 - edit)
			if (code == 16 || (code >= 112 && code <= 123 && !f2)) return;

			const sel = view.getSelectedId(true);
			if (sel.length){
				if(!(view.config.liveEditor && f2))
					grid.$anyKey = true;
				grid.edit(sel[0]);
			}
		}, grid);

		webix.UIManager.addHotKey("enter", (view) => {
			const sel = view.getSelectedId(true);
			if (sel.length){
				if(!(view.config.liveEditor && !grid.callEvent("onBeforeLiveEditor", [sel[0]])))
					grid.edit(sel[0]);
			}
		}, grid);

		webix.UIManager.addHotKey(key+"-enter", () => {
			const editor = grid.getEditor();
			if (editor){
				view.groupUndo(()=>{
					const value = editor.getValue();
					const math = value[0] == "=" && value.length > 1;

					grid.editCancel();

					const areas = grid.getAllSelectAreas();
					for(let name in areas){
						const area = areas[name];
						for(let r = area.start.row; r <= area.end.row; r++)
							for(let c = area.start.column; c <= area.end.column; c++)
								view.setCellValue(
									r,
									c,
									math ? view._mData.getStore().transposeMath(value, r-editor.row, c-editor.column) : value
								);
					}

					grid.moveSelection("down");
				});
			}
		}, grid);

		webix.UIManager.addHotKey("backspace", () => del(view), grid);
		webix.UIManager.addHotKey("delete", () => del(view), grid);

		const redo = webix.env.isMac ? "command-shift-z" : "ctrl-y";
		webix.UIManager.addHotKey(redo, () => view.redo(), grid);
		webix.UIManager.addHotKey(key+"-z", () => view.undo(), grid);

		webix.UIManager.addHotKey(key+"-b", () => styleHotKey(view, "font-weight"), grid);
		webix.UIManager.addHotKey(key+"-i", () => styleHotKey(view, "font-style"), grid);
		webix.UIManager.addHotKey(key+"-u", (v, e) => ctrlU(view, e), grid);

		const strike = webix.env.isMac ? "command-shift-x" : "ctrl-alt-s";
		webix.UIManager.addHotKey(strike, () => styleHotKey(view, "strike"), grid);

		webix.UIManager.addHotKey("alt-shift-left", (v, e) => groupDialog(view, "ungroup", e), grid);
		webix.UIManager.addHotKey("alt-shift-right", (v, e) => groupDialog(view, "group", e), grid);
		webix.UIManager.addHotKey("alt-shift-up", (v, e) => setGroupOpen(view, false, e), grid);
		webix.UIManager.addHotKey("alt-shift-down", (v, e) => setGroupOpen(view, true, e), grid);
	}
}

function del(view) {
	const grid = view.$$("cells");
	if(!grid.getEditor())
		group.set(function(){
			const areas = grid.getAllSelectAreas();
			for(let name in areas){
				const area = areas[name];
				for(let r = area.start.row; r <= area.end.row; r++)
					for(let c = area.start.column; c <= area.end.column; c++)
						view.setCellValue(r, c, "");
			}
			view.refresh();
		});
}

function zoom(view, value, e) {
	view.zoom(value);
	return webix.html.preventEvent(e);
}

function ctrlU(view, e) {
	styleHotKey(view, "underline");
	return webix.html.preventEvent(e);
}

function dialog(id, view, e) {
	view.callEvent("onCommand",[{id}]);
	return webix.html.preventEvent(e);
}

function groupDialog(view, action, e) {
	view.callEvent("onCommand", [
		{ id: "select-group-type", groupAction: action },
	]);
	return webix.html.preventEvent(e);
}

function setGroupOpen(view, open, e) {
	const rowZones = getSelectedZones(view, "row");
	const colZones = getSelectedZones(view, "column");
	group.set(() => {
		if (rowZones)
			rowZones.forEach(z =>
				setOpenByRange(view, "row", [z.start.row, z.end.row], open)
			);
		if (colZones)
			colZones.forEach(z =>
				setOpenByRange(
					view,
					"column",
					[z.start.column, z.end.column],
					open
				)
			);
	});
	return webix.html.preventEvent(e);
}

function styleHotKey(view, attr) { 
	var cell = view.getSelectedId();
	if(cell){
		var style = view.getStyle(cell.row, cell.column);

		var elementOn = styleFormats[attr]||attr;
		var elementOff = "normal";

		var state = (style && style.props[attr] === elementOn)? elementOff : elementOn;
		view.callEvent("onStyleSet", [attr, state]);
	}
}

function onWheel(view, grid, e){
	if (e.ctrlKey || e.metaKey) {
		zoom(view, e.deltaY < 0 ? "in" : "out", e);
		return;
	}

	if (
		!e.target.closest(
			".webix_ssheet_column_groups, .webix_ssheet_row_groups, .webix_ssheet_group_intersection"
		)
	)
		return;

	// normalization logic from grid wheel handler (for consistency)
	const step = e.deltaMode === 0 ? 30 : 1;
	const maxLines = 3;
	const normalize = delta => {
		const d = delta / step;
		return (
			(e.deltaMode === 1 && Math.abs(d) > maxLines
				? Math.sign(d) * maxLines
				: d) * 30
		);
	};

	let dx = 0,
		dy = 0;
	if ((e.deltaX && Math.abs(e.deltaX) > Math.abs(e.deltaY)) || e.shiftKey)
		dx = normalize(e.shiftKey ? e.deltaY : e.deltaX);
	else dy = normalize(e.deltaY);

	if (dx || dy) {
		const { x, y } = grid.getScrollState();
		grid.scrollTo(x + dx, y + dy);
		webix.html.preventEvent(e);
	}
}